import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { route } from "../static/route";

const isAuthFailed = (obj: any): boolean =>
  obj?.response?.auth === false ||
  obj?.response?.auth === "false" ||
  obj?.auth === false ||
  obj?.auth === "false" ||
  obj?.response?.data?.auth === false ||
  obj?.response?.data?.auth === "false" ||
  obj?.data?.auth === false ||
  obj?.data?.auth === "false";

const extractMessage = (obj: any, fallback: string): string =>
  typeof obj === "string"
    ? obj
    : obj?.data?.message ||
      obj?.response?.data?.message ||
      obj?.response?.message ||
      obj?.message ||
      fallback;

const toastOptions = {
  position: "top-right" as const,
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export function useToastHandler() {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuth();

  const handleAuthFailure = useCallback(() => {
    localStorage.removeItem("authToken");
    setIsAuthenticated(false);
    navigate(route.login);
  }, [navigate, setIsAuthenticated]);

  const handleError = useCallback(
    (error: any) => {
      if (isAuthFailed(error)) {
        handleAuthFailure();
        return;
      }
      toast.error(
        extractMessage(error, "કઈંક ખોટું થયું, કૃપા કરીને ફરી પ્રયાસ કરો."),
        toastOptions
      );
    },
    [handleAuthFailure]
  );

  const handleSuccess = useCallback(
    (response: any) => {
      if (isAuthFailed(response)) {
        handleAuthFailure();
        return;
      }
      toast.success(
        extractMessage(response, "સફળતાપૂર્વક અપડેટ થયો."),
        toastOptions
      );
    },
    [handleAuthFailure]
  );

  return { handleError, handleSuccess };
}
